import { Button } from '@material-ui/core';
import React, { useRef, useState} from 'react';


import 'react-toastify/dist/ReactToastify.css';

import TextField from '@material-ui/core/TextField';





import MUIDataTable from "mui-datatables";
export default function PiracyPornAnalyser() {

  const json = useRef()
  const wynik = useRef()
  const tableRef = useRef();

  const [datatableData,setdatatableData] = useState([]);
    function Action()
    {
      setdatatableData([])
      wynik.current.innerHTML = "";
      var domain = json.current.value;
      //var kwds = json2.current.value;
      //var Keywords = kwds.split(";");
      const domains = domain.split("\n");
      //console.log(Domains)
      //console.log(Keywords)
      const MainUrl = "https://mobileappscrapper.herokuapp.com/piracyporn/";
      
      
      for (const value of domains) {
        fetch(MainUrl + value)
        .then(response => response.json())
        .then(data => setdatatableData(datatableData => [...datatableData,[JSON.parse(data).Domain, JSON.parse(data).PiracyScore, JSON.parse(data).PornScore]]))
        .catch((error) => {
          setdatatableData(datatableData => [...datatableData,[value, "No data", "No data"]])
        });
      }
       /*
      for(let element in Scores)
      {
        
        Scor[element] = 
        {
          Result: Scores[element]
        }
        //setdatatableData(datatableData => [...datatableData,[Scor[element].Result.Domain, Scor[element].Result.PiracyScore, Scor[element].Result.PornScore]])
      }
   
     
      for(let element in Domains)
      {
        
        fetch(MainUrl + PornData + "/" + Domains[element])
        .then(response => response.json())
        .then(data => PornDane.push(data))
        .catch((error) => {}
        )

      }


      //AddDomains.current.style.display = "None";
      //json.current.disabled = 'true';
*/
    }
    
  return (
    <div >
{/* <Checkbox {...label} onChange={ChangeVariant} />Use secondary variant of crawl method 
      <TextField variant="outlined" multiline inputRef={json2} rows={10} placeholder="Insert keywords separated by ; " id="tocheck" style={{borderRadius:"10px",textAlign:"center",width:"100%",height:"300px",resize:"vertical"}} className="inline-txtarea"></TextField>
  */}    
      <br></br>
       <TextField variant="outlined" multiline inputRef={json} rows={10} placeholder="Insert domains separated by line break" id="tocheck" style={{borderRadius:"10px",textAlign:"center",width:"100%",height:"300px",resize:"vertical"}} className="inline-txtarea"></TextField>
       
 
    <br></br>
    <Button variant="contained" color="primary"  onClick={Action}>Analyse</Button>
    <p> </p>
    <div ref={wynik}>
    

    </div>
    <MUIDataTable
            
            title="Results"
            ref={tableRef}
            columns={["Domain", "PiracyRiskScore", "PornRiskScore"]}
            data={datatableData}
            options={{
              filterType: "checkbox",
              downloadOptions: {
                filename: 'PornPiracyAnalyser_' + new Date().toISOString().slice(0, 10) + '.csv'
              },
              textLabels: {
                body: {
                  noMatch: "Please scan websites first",
                }},
            }}
            
          />
    </div>
  );
}
